const galleryPl = {
    "file_upload_successful": "Pomyślne przesłanie pliku",
    "file_upload_error": "Błąd przesyłania pliku",
    "attach_files": "Dołącz pliki",
    "files_selected": "Wybrane pliki",
    "upload": "Wgrywać",
    "uploading": "Przesyłanie",
    "maximum_file_size": "Maksymalny rozmiar przesyłanego pliku wynosi 10 MB.",
    "download": "Pobierać",
    "open_in_new_tab": "Otwórz w nowej karcie",
    "delete_file": "Usuń plik",
    "confirm_delete": "Czy na pewno chcesz usunąć ten plik?",
    "image_in_use": "Wybrany obraz jest używany w następujących aktywnych pozycjach menu:",
    "image_in_use_tip": "Aby usunąć ten plik, usuń go ze wszystkich aktywnych ofert.",
    "file_deleted_successfully": "Plik został pomyślnie usunięty",
    "error_deleting_file": "Błąd podczas usuwania pliku",
    "confirm_selection": "Potwierdź wybór",
    "file_deletion_forbidden": "Zabronione usuwanie plików"
};

export default galleryPl;
